var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "outage-banner-wrapper" },
    [
      _c("modal-header", {
        attrs: { title: _vm.outageTitle, "on-modal-close": _vm.close }
      }),
      _vm._v(" "),
      _c("div", {
        staticClass: "content pb-5 px-5",
        domProps: { innerHTML: _vm._s(_vm.outageMessage) }
      }),
      _vm._v(" "),
      _c("modal-footer", {
        staticClass: "text-center",
        attrs: { buttonConfigs: [_vm.buttonConfig] }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-4781e881", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4781e881","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/homebase/OutageBannerModal.vue
// module id = null
// module chunks = 